import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const dynamicDeleteEndpoint = ApiEndpoints.serviceDynamic.delete;
const dynamicListEndpoint = ApiEndpoints.serviceDynamic.list;
const dynamicEditPath = "edit-service-dynamic";
const tableHeader = ["Title", "Description", "Slug"];
const tbody = ["section1_title", "section1_description", "slug"];

// Keep rich text in storage; show readable text in the table and its exports.
const descriptionText = html => {
  const template = document.createElement("template");
  template.innerHTML = String(html || "").replace(/<\/(?:p|div|li|h[1-6])>|<br\s*\/?\s*>/gi, "$& ");
  template.content.querySelectorAll("script, style").forEach(node => node.remove());
  return (template.content.textContent || "").replace(/\s+/g, " ").trim();
};

export default function DynamicListing() {
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", dynamicListEndpoint);
      const result = (response.dynamic_pages || []).map(page => ({
        ...page,
        section1_title: page.hero?.title || "",
        section1_description: descriptionText(page.hero?.description),
      }));
      setData(result);
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to load dynamic pages.");
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (dynamicpage_id) => {
    if (!window.confirm("Delete this dynamic page?")) return;
    const payload = { dynamicpage_id };
    try {
      const response = await ApiRequest("POST", dynamicDeleteEndpoint, payload);
      toast.success(response.message);
      dataFetch();
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to delete dynamic page.");
    }
  };

  const pagename = {
    name: "Service Dynamic Page",
    user: "Admin",
    innerpage: "Service Dynamic Page",
  };

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-service-dynamic">Add +</Link>
          <DataTable
            data={data}
            tableHeader={tableHeader}
            tbody={tbody}
            editPath={dynamicEditPath}
            onDelete={handleDelete}
          />
      </div>
    </>
  );
}
